<template>
    <div>
        <h2
            v-if="isHeadingH2"
            v-html="title"
        />
        <h1
            v-else
            v-html="title"
        />
    </div>
</template>

<script>
export default {
    name: 'GenericContentTitle',
    props: {
        isHeadingH2: {
            type: Boolean,
            default() {
                return false;
            }
        },
        title: {
            type: String,
            default() {
                return null;
            }
        }
    }
};
</script>
